import Vue from "vue";
import Vuex from "vuex";
import Service from "@/service/api-hr";
import router from "@/router/index";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        profile : {
            accounts:{
                userinfo:{
                    prefix:null,
                    firstName:null,
                    lastName:null
                }
            }
        }
    },

    mutations: {
        profile(state, obj) {
            state.profile = obj;
        }
    },

    actions: {
        config({commit}, data) {
            Service.personal('exp', data, {})
                .then((response) => {
                    store.commit("personal/profile", response.data.data)
                }).catch((err) => {
            });
        }
    },

    getters: {
        profile(state, obj) {
            return state.profile;
        },
    },
};

export default ServerModule;
